import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { IMG_INTERIOR } from "../../lib/assets";
import { useLang } from "../../lib/i18n";

export const Zones = () => {
  const { t } = useLang();
  return (
    <section id="zones" className="relative bg-[#0A192F] py-24 md:py-32 overflow-hidden" data-testid="zones-section">
      <div className="noise-overlay" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="md:col-span-5 order-2 md:order-1"
        >
          <div className="relative aspect-[3/4] overflow-hidden">
            <img src={IMG_INTERIOR} alt={t.zones.imgAlt} className="w-full h-full object-cover" />
            <div className="absolute inset-0 border border-[#C9A03C]/30 m-5 pointer-events-none" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="md:col-span-6 md:col-start-7 order-1 md:order-2"
        >
          <p className="font-script text-[#C9A03C] text-2xl mb-4">{t.zones.eyebrow}</p>
          <h2 className="font-serif-lux text-3xl sm:text-4xl text-[#F0F0F0] font-medium leading-tight mb-10">
            {t.zones.title}
          </h2>
          <div className="space-y-8">
            <div className="flex items-start gap-5 group" data-testid="zone-paris">
              <MapPin className="w-6 h-6 text-[#C9A03C] mt-1 shrink-0" strokeWidth={1.5} />
              <div>
                <h3 className="font-serif-lux text-2xl text-[#F0F0F0] font-semibold mb-2">{t.zones.parisTitle}</h3>
                <p className="text-[#F0F0F0]/60 font-light leading-relaxed">{t.zones.parisText}</p>
              </div>
            </div>
            <div className="w-full h-px gold-line opacity-40" />
            <div className="flex items-start gap-5 group" data-testid="zone-bourgogne">
              <MapPin className="w-6 h-6 text-[#C9A03C] mt-1 shrink-0" strokeWidth={1.5} />
              <div>
                <h3 className="font-serif-lux text-2xl text-[#F0F0F0] font-semibold mb-2">{t.zones.bourgogneTitle}</h3>
                <p className="text-[#F0F0F0]/60 font-light leading-relaxed">{t.zones.bourgogneText}</p>
              </div>
            </div>
          </div>
          <p className="mt-10 text-sm text-[#F0F0F0]/40 font-light tracking-wide">{t.zones.footerLine}</p>
        </motion.div>
      </div>
    </section>
  );
};
